import React from 'react';
import Slider from "react-slick";
import {Img, A} from 'views/AppElements';
import AppUtil from 'AppUtil';

const BASIC_SLIDER_SETTINGS = {speed: 350, className: 'headerSlickSlider', 
								cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
								autoplay: true,
								autoplaySpeed: 3500,
								dots: true,
								arrows: false,
								slidesToShow: 1,
								swipeToSlide: true, 
								swipe: true, 
								infinite: true,
								responsive: [
									{
										breakpoint: 600,
										settings: {
											dots: true,
											arrows: true,
										}
									}
								]
							};

const EachBanner = ({banner}) => {
	let imgTag = null;

	if(banner.mobileImg && AppUtil.isMobileDevice())
		imgTag = <Img className='bannerImg' src={banner.mobileImg} alt={banner.title} />;
	else
		imgTag = <Img className='bannerImg' src={banner.img} alt={banner.title} />;

	return <div className='bannerImgContainer'>
				{
					banner.url && 
					<A href={banner.url}>{imgTag}</A>
				}

				{
					!banner.url && 
					imgTag
				}
		</div>
};

const BannerLoader = ({title}) => {
	const bannerTitle = title? title.toUpperCase(): null;
	return <div className='bannerImgContainer'>
			<h1 className='bannerTitle'>{bannerTitle}</h1>
		</div>;
};

const HeaderBanner = ({bannerImages, title, autoplay, navigator = "dots"}) => {
	const banners = bannerImages? bannerImages.filter(bi => !bi.expiration || new Date().getTime() < bi.expiration).map(bi => <EachBanner key={bi.title} banner={bi}/>): null;
	if(!banners)
		return <BannerLoader title={title} />;

	if(banners.length === 0) return null;

	const settings = Object.assign({}, BASIC_SLIDER_SETTINGS);
	if(autoplay !== undefined && autoplay !== null)
		settings.autoplay = autoplay;

	return <div style={{width: '100%'}}>
			<Slider {...settings}>
			{banners}
		</Slider>
	</div>
};

export default HeaderBanner;


// WEBPACK FOOTER //
// ./src/views/HeaderBanner.js